export default "__VITE_ASSET__e789701f__"